/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { Typography, Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import styles from "../devotee.module.scss";
import EmptySCMember from "../../../assets/emptySCMember.svg";
import commonStyles from "../../../App.module.scss";
import { useNavigate } from "react-router-dom";
import constants from "../../../config/constants.json";
import {
  CommonButton,
  CustomCalendarOutlinedIcon,
  HcccCard,
} from "../../common/StyledComponents/StyledFields";
import Grid from "@mui/material/Grid";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../../infrastructure/backendService";
import EmptyPage from "../../common/emptyPages/emptyPage";
import apiPath from "../../../config/apiPaths.json";
import toast from "react-hot-toast";
import ErrorPopup from "../../common/ErrorPopup";

const UpcommingScMember = (): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  // const [searchQuery, setSearchQuery] = useState<string>('');
  // const [filteredScMemberDetails, setFilteredScMemberDetails] = useState<any[]>([]);
  const [SCmeetingListData, setSCmeetingListData] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [meetingName, setmeetingName] = useState<string>("");
  const [host, setHost] = useState<string>("");
  const [meetingDate, setMeetingDate] = useState<string>("");
  const [meetingDataList, setMeetingDataList] = useState<any[]>([]);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.meetingOfMinutes,
      includeToken: true,
      params: {
        page: pageNumber - 1,
        size: 10,
      },
    })
      .then((res) => {
        setSCmeetingListData(res.data.content);
        setTotalRecords(res.data.totalElements);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, [pageNumber]);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.upComingSCMeeting,
      includeToken: true,
    })
      .then((res) => {
        setMeetingDataList(res.data);
        if (res.data.length > 0) {
          setmeetingName(res.data[0].meetingName);
          setMeetingDate(res.data[0].meetingDate);
          setHost(res.data[0].meetingHost);
        } else {
          setmeetingName("");
          setMeetingDate("");
          setHost("");
        }
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  const handleDonateButton = (): void => {
    navigate("/donations");
  };

  const emptyPageButton = (): React.ReactElement => {
    return (
      <div style={{ marginTop: "14px" }}>
        <CommonButton
          className={commonStyles.saveButton}
          onClick={handleDonateButton}
        >
          Donate
        </CommonButton>
      </div>
    );
  };

  const upComingSCmeetingCard = () => {

   const firstFourMeetings = meetingDataList.slice(0, 4);
   
    return (
      <div>
        {/* <Typography component={"p"} className={styles.text}>
          {meetingName}
        </Typography> */}
        {firstFourMeetings.map((item, index) => (
          <div key={index} className={styles.cardContainer}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginBottom: "10px",
                }}
              >
                <Typography
                  component={"p"}
                  className={styles.innerText}
                  style={{ fontWeight: "600" }}
                >
                  {item.meetingName}
                </Typography>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <CustomCalendarOutlinedIcon />
                  <Typography component={"p"} className={styles.innerText}>
                    {item.meetingDate}
                  </Typography>
                </div>
              </div>

              <Typography component={"p"} className={styles.innerText}>
                Host: {item.meetingHost}
              </Typography>
              {item.meetingDescription && (
                <Typography component={"p"} className={styles.innerText}>
                  Desrciption: {item.meetingDescription}
                </Typography>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const upComingSCmeeting = () => {
    return (
      <div className={styles.UpscContainer}>
        <Typography className={styles.scheader}>Upcoming SC Meeting</Typography>
        {meetingDataList.length > 0 ? (
          upComingSCmeetingCard()
        ) : (
          <Typography component={"p"} className={styles.text}>
            No Data
          </Typography>
        )}
      </div>
    );
  };

  const showBecomeMember = (): React.ReactElement => {
    return (
      <>
        <Grid item xs={6} md={8} />
        <Grid item xs={6} md={12} spacing={2}>
          <HcccCard sx={{ height: "421px", padding: "24px", margin: "5px 0" }}>
            <Box sx={{ justifyContent: "space-between" }}>
              <Typography
                sx={{
                  color: "#313131",
                  fontFamily: "Lato",
                  fontSize: "24px",
                  fontStyle: " normal",
                  fontWeight: 600,
                  lineHeight: "140%",
                  paddingBottom: "8px",
                }}
              >
                Want to be an SC Member?
              </Typography>
              <Typography
                sx={{
                  fontSize: "16px",
                }}
              >
                Interested in taking active role in steering the temple
                direction? Become a Steering Committee member.
              </Typography>
            </Box>
            <EmptyPage
              imgUrl={EmptySCMember}
              subComponent={emptyPageButton()}
              typographyText={""}
            />
          </HcccCard>
        </Grid>
      </>
    );
  };

  const showScMember = (): React.ReactElement => {
    return (
      <Box className={styles.showScMembersContainer}>
        {
          <Grid item xs={6} md={12} spacing={2}>
            {upComingSCmeeting()}
          </Grid>
        }
      </Box>
    );
  };

  return (
    <Box className={styles.ScMemberLayout}>
      {SCmeetingListData.length !== 0 ? showScMember() : showBecomeMember()}
    </Box>
  );
};

export default UpcommingScMember;
